<script>
  import Video from './video.svelte'
  import PictureFrame from './pictureframe/pictureframe.svelte'
  import Text from './text.svelte'
  import Varmelding from './varmelding.svelte'
  import Julepynt from './julepynt.svelte'

  export let text
  export let data
  export let useTextAsLink
  export let type
  export let pictureLeanTowards = undefined

  function getLinktext(entry) {
    let linkText = 'Se i NRKTV'
    if (useTextAsLink) {
      linkText = entry.text
    }
    if (entry.nyttar?.linkText) {
      linkText = entry.nyttar.linkText
    }
    return linkText
  }

  const showText = type !== 'nyttarstale'
  const summaryClass = `summary-wrapper ${type}`

  const components = {
    video: Video,
    image: PictureFrame,
    julepynt: Julepynt,
  }
</script>

{#if data.length}
  {#if text}
    <Text>
      {@html text}
    </Text>
  {/if}
  {#if type === 'varmelding' && data.length > 1}
    <Varmelding {data} />
  {:else}
    {#each data as entry}
      <svelte:component
        this={components[entry.type]}
        data={entry}
        {showText}
        leanTowards={pictureLeanTowards}
      />
      {#if type === 'nyttarstale' || entry.link}
        <div class={summaryClass}>
          {#if type === 'nyttarstale'}
            <blockquote class="quote">{entry.text}</blockquote>
          {/if}
          {#if entry.link || entry.nyttar?.linkText}
            <a class="link" target="_blank" href={entry.link}>
              <span>{getLinktext(entry)}</span>
              <svg style="width: 2em; height: 2em" focusable="false" aria-hidden="true">
                <use xlink:href="#nrk-arrow-right" /></svg
              >
            </a>
          {/if}
        </div>
      {/if}
    {/each}
  {/if}
{/if}

<style>
  .summary-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-left: auto;
    z-index: 1;
  }

  .summary-wrapper.nyttarstale {
    margin-top: -70px;
  }
  .quote {
    background: #192f4d;
    border-radius: 8px;
    font-size: 16px;
    padding: 24px;
    font-weight: 400;
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
  }

  .link {
    display: flex;
    margin-left: auto;
    background: #192f4d;
    text-decoration: none;
    border-radius: 4px;
    font-size: 16px;
    padding: 14px;
    font-weight: 700;
    align-items: center;
  }

  .link svg {
    margin-left: 20px;
  }
</style>
